import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface Tier {
  name: string;
  setup: string;
  monthly: string;
  note?: string;
}
interface Group {
  title: string;
  tiers: Tier[];
}
const groups: Group[] = [{
  title: 'SISTEMA COMERCIAL',
  tiers: [{
    name: 'START',
    setup: '$1.200.000',
    monthly: '$300.000/mes'
  }, {
    name: 'GROWTH',
    setup: '$2.500.000',
    monthly: '$650.000/mes'
  }, {
    name: 'PRO',
    setup: '$4.500.000',
    monthly: '$1.200.000/mes'
  }]
}, {
  title: 'SISTEMA COMPLETO',
  tiers: [{
    name: 'START',
    setup: '$4.500.000',
    monthly: '$500.000/mes'
  }, {
    name: 'GROWTH',
    setup: '$6.000.000',
    monthly: '$900.000/mes'
  }, {
    name: 'PRO',
    setup: '$8.000.000',
    monthly: '$1.450.000/mes'
  }]
}, {
  title: 'VOICE',
  tiers: [{
    name: 'START',
    setup: '$2.000.000',
    monthly: '$900.000/mes',
    note: '750 minutos incluidos'
  }, {
    name: 'GROWTH',
    setup: '$3.000.000',
    monthly: '$1.600.000/mes',
    note: '1.500 minutos incluidos'
  }, {
    name: 'SCALE',
    setup: '$4.500.000',
    monthly: '$2.800.000/mes',
    note: '3.000 minutos incluidos'
  }, {
    name: 'ENTERPRISE',
    setup: 'Cotización personalizada',
    monthly: ''
  }]
}];
interface PricingDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PricingDetailModal({
  isOpen,
  onClose
}: PricingDetailModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-150" data-mp="25zthe5p0f611">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[200] bg-carbon/60 backdrop-blur-sm flex items-center justify-center p-4 md:p-8" role="presentation" onClick={onClose} data-id="element-151" data-mp="1mtm04jo0w496">
          <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} role="dialog" aria-modal="true" aria-labelledby="pricing-detail-title" className="relative bg-arena rounded-[12px] max-w-[720px] w-full max-h-[85vh] overflow-y-auto p-8 md:p-10" onClick={e => e.stopPropagation()} data-id="element-152" data-mp="182d3hqlpdimj">
            <button onClick={onClose} aria-label="Cerrar" className="absolute top-6 right-6 text-carbon/50 hover:text-carbon transition-colors duration-150" data-id="element-153" data-mp="ffit5milnzms">
              <X size={20} data-id="element-154" data-mp="2w39yx8w66r3j" />
            </button>

            <h3 id="pricing-detail-title" className="font-display text-[24px] md:text-[28px] font-bold text-carbon mb-1.5" data-id="element-155" data-mp="2vzw20g69za3h">
              Configuraciones detalladas
            </h3>
            <p className="font-body text-[14px] text-carbon/55 mb-8" data-id="element-156" data-mp="3aro1rjtl6fk3">
              Niveles de implementación por sistema. Elegimos el nivel
              correcto contigo según el alcance real de tu proceso.
            </p>

            <div className="space-y-8" data-id="element-157" data-mp="3jt4dpw01upqf">
              {groups.map(group => <div key={group.title} data-id="element-158" data-mp="3or5vmdlqoj0b">
                  <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-3" data-id="element-159" data-mp="3oq4j04p2rogh">
                    {group.title}
                  </span>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3" data-id="element-160" data-mp="1udxuk4767b68">
                    {group.tiers.map(tier => <div key={tier.name} className="bg-arena-dark border border-carbon/10 rounded-[12px] p-4" data-id="element-161" data-mp="3kw34l9lfjen2">
                        <span className="block font-display text-[13px] font-bold text-carbon mb-2" data-id="element-162" data-mp="3ttvlujapowd3">
                          {tier.name}
                        </span>
                        <span className="block font-body text-[13px] text-carbon/70" data-id="element-163" data-mp="324k2d4z8c4m3">
                          {tier.setup}
                          {tier.monthly && ' implementación'}
                        </span>
                        {tier.monthly && <span className="block font-body text-[13px] font-medium text-carbon mt-0.5" data-id="element-164" data-mp="3653x61wbyw52">
                            {tier.monthly}
                          </span>}
                        {tier.note && <span className="block font-body text-[11px] text-carbon/45 mt-1.5" data-id="element-165" data-mp="2ed4y36nw7d87">
                            {tier.note}
                          </span>}
                      </div>)}
                  </div>
                </div>)}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}